import { ANYWHERE_NAME, ANYWHERE_PLACE_ID } from './search'

export type OfferTypeId =
  | 'hotels'
  | 'tours'
  | 'cruises'
  | 'ultra-lux'
  | 'experiences'
  | 'flights'
  | 'car-hire'
  | 'homes-and-villas'

function createOfferTypeItem(
  id: OfferTypeId,
  to: string,
  imageId: string,
): App.OfferTypeListItem {
  return {
    id,
    to,
    image: { id: imageId },
  }
}

export const LE_HOMES_AND_VILLAS_TO = `/search/homes-and-villas?destinationId=${ANYWHERE_PLACE_ID}&destinationName=${ANYWHERE_NAME}&adults=2&children=none`

export const WHITELABEL_OFFER_TYPES_LIST: Array<App.OfferTypeListItem> = [
  createOfferTypeItem('hotels', '/hotels', 'z80zrcgh6bkj02proi2u'),
  createOfferTypeItem('tours', '/tours', 'mk80m0gxlssagpxj329v'),
  createOfferTypeItem('cruises', '/cruises', 'wioy2m740nyf1gzxbr3v'),
  createOfferTypeItem('ultra-lux', '/ultra-lux', '5rw20hquxqn9qozzg79p'),
  createOfferTypeItem('experiences', '/experiences', 'qi3ef974zw6vi0d8xqw'),
  createOfferTypeItem('flights', '/flights', 'fvp335n5vdcvhn6j1t4o'),
  createOfferTypeItem('car-hire', '/car-hire', '9335qyg92rdg07zgot07'),
]

export const LE_OFFER_TYPES_LIST: Array<App.OfferTypeListItem> = [
  createOfferTypeItem('hotels', '/hotels', 'k58oh9ebyasvjo9ndff'),
  createOfferTypeItem('tours', '/tours', 'exu2capyq66fvv752yc4'),
  createOfferTypeItem('cruises', '/cruises', 'wioy2m740nyf1gzxbr3v'),
  createOfferTypeItem('ultra-lux', '/ultra-lux', '5rw20hquxqn9qozzg79p'),
  createOfferTypeItem('homes-and-villas', LE_HOMES_AND_VILLAS_TO, 'c9f8da1e-439a-4301-9a5d-0ec10be87ba7'),
  createOfferTypeItem('experiences', '/experiences', 'ufils1y5jgf0yhvf5utk'),
  createOfferTypeItem('flights', '/flights', 'fvp335n5vdcvhn6j1t4o'),
  createOfferTypeItem('car-hire', '/car-hire', 'afof01h0vxhcgx9iygmn'),
]
